import { render, staticRenderFns } from "./TaskPriorityEdit.vue?vue&type=template&id=58349742&"
import script from "./TaskPriorityEdit.vue?vue&type=script&lang=js&"
export * from "./TaskPriorityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports